var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalOpening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 99,
    viewBox: "0 0 105 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4383_15168)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 49.5361,
    height: 49.5361,
    rx: 7.86288,
    fill: "#12B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0519 49.1874H42.4913C38.4977 49.1874 36.5009 49.1874 35.2602 47.9232C34.0195 46.659 34.0195 44.6242 34.0195 40.5546C34.0195 36.4851 34.0195 34.4504 35.2602 33.1861C36.5009 31.9219 38.4977 31.9219 42.4913 31.9219H46.7272C50.7208 31.9219 52.7177 31.9219 53.9584 33.1861C54.9129 34.1588 55.133 35.5876 55.1838 38.0483",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8527 40.5595C51.0583 40.3701 51.1611 40.2754 51.286 40.2754C51.4109 40.2754 51.5137 40.3701 51.7193 40.5595L52.5132 41.2909C52.6091 41.3793 52.657 41.4235 52.7166 41.4453C52.7762 41.4673 52.8413 41.4647 52.9717 41.4596L54.0443 41.4175C54.3204 41.4066 54.4585 41.4012 54.5532 41.4808C54.6479 41.5603 54.6663 41.6973 54.7031 41.9712L54.8509 43.0687C54.868 43.1956 54.8766 43.259 54.9074 43.3131C54.9384 43.3673 54.9886 43.4068 55.0892 43.486L55.953 44.166C56.1668 44.3344 56.2737 44.4185 56.2949 44.5388C56.3161 44.6591 56.2443 44.7746 56.1009 45.0058L55.5149 45.95C55.4479 46.058 55.4145 46.112 55.4038 46.1731C55.3931 46.234 55.4063 46.2963 55.4328 46.4206L55.6653 47.5104C55.7224 47.7782 55.751 47.9121 55.6896 48.0185C55.6283 48.1248 55.4981 48.1672 55.2378 48.252L54.2067 48.5878C54.0838 48.6278 54.0223 48.6479 53.9743 48.6885C53.9263 48.7293 53.8965 48.7866 53.8371 48.9014L53.3334 49.8722C53.2049 50.1196 53.1408 50.2432 53.0238 50.2859C52.9068 50.3285 52.7781 50.2752 52.5207 50.1683L51.5311 49.7579C51.4101 49.7077 51.3497 49.6827 51.286 49.6827C51.2223 49.6827 51.1619 49.7077 51.0409 49.7579L50.0513 50.1683C49.7939 50.2752 49.6651 50.3285 49.5482 50.2859C49.4312 50.2432 49.3671 50.1196 49.2386 49.8722L48.7349 48.9014C48.6754 48.7866 48.6457 48.7293 48.5977 48.6885C48.5497 48.6479 48.4882 48.6278 48.3653 48.5878L47.3342 48.252C47.0739 48.1672 46.9436 48.1248 46.8824 48.0185C46.821 47.9121 46.8496 47.7782 46.9067 47.5104L47.1391 46.4206C47.1656 46.2963 47.1789 46.234 47.1682 46.1731C47.1575 46.112 47.1241 46.058 47.057 45.95L46.4711 45.0058C46.3277 44.7746 46.2559 44.6591 46.2771 44.5388C46.2982 44.4185 46.4052 44.3344 46.6189 44.166L47.4828 43.486C47.5834 43.4068 47.6336 43.3673 47.6646 43.3131C47.6954 43.259 47.704 43.1956 47.721 43.0687L47.8689 41.9712C47.9057 41.6973 47.9241 41.5603 48.0188 41.4808C48.1135 41.4012 48.2516 41.4066 48.5277 41.4175L49.6003 41.4596C49.7306 41.4647 49.7958 41.4673 49.8554 41.4453C49.915 41.4235 49.9629 41.3793 50.0588 41.2909L50.8527 40.5595Z",
    stroke: "white",
    strokeWidth: 1.67086
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6151 31.9221L49.5043 31.5779C48.953 29.8624 48.6773 29.0046 48.0208 28.514C47.3645 28.0234 46.4927 28.0234 44.749 28.0234H44.4559C42.7122 28.0234 41.8403 28.0234 41.184 28.514C40.5276 29.0046 40.2519 29.8624 39.7005 31.5779L39.5898 31.9221",
    stroke: "white",
    strokeWidth: 1.67086
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4383_15168",
    x: -14.5967,
    y: -20.5967,
    width: 118.728,
    height: 118.728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2983
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4383_15168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4383_15168",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOpening);
export default __webpack_public_path__ + "static/media/TotalOpening.d7afc58650778a74cd88a4d37a5c531f.svg";
export { ForwardRef as ReactComponent };